import { createIcon } from '@chakra-ui/icon';
export var SearchIcon = createIcon({
  displayName: 'SearchIcon',
  d: 'M2 10a8 8 0 1116 0 8 8 0 01-16 0zm8-10C4.477 0 0 4.477 0 10s4.477 10 10 10a9.958 9.958 0 006.329-2.257l5.964 5.964a1 1 0 001.414-1.414l-5.964-5.964A9.958 9.958 0 0020 10c0-5.523-4.477-10-10-10z'
});
//# sourceMappingURL=Search.js.map